import { observer } from "mobx-react";
import React from "react";
import {
  BodyGramResult,
  UserProfileQuizAnswerStore,
} from "stores/UserProfileStore";
import { computed } from "mobx";
import { Column, GroupRow, Row } from "./styles";
import SimpleField from "components/SimpleField";

type Props = {
  userId?: number;
  bodyGramId: number;
};

@observer
class BodyGramDetail extends React.Component<Props> {
  @computed get log() {
    if (BodyGramResult.data) {
      return this.chunckArrayInGroups(
        BodyGramResult.data?.metadata?.results?.measurements,
        2,
      );
    }

    return undefined;
  }

  async componentDidMount() {
    const { userId, bodyGramId } = this.props;
    await BodyGramResult.fetchData(userId, bodyGramId);
  }

  chunckArrayInGroups = (arr: any, size: number) => {
    console.log(arr);
    var chunk = [];
    var i; // declara array vacio e indice de for
    for (
      i = 0;
      i <= arr.length;
      i += size // loop que recorre el array
    )
      chunk.push(arr.slice(i, i + size)); // push al array el tramo desde el indice del loop hasta el valor size + el indicador
    return chunk;
  };

  async componentDidUpdate(prevProps: Props) {
    const { userId, bodyGramId } = this.props;
    if (prevProps.bodyGramId !== bodyGramId) {
      await UserProfileQuizAnswerStore.fetch(userId, bodyGramId);
    }
  }

  toTitleCase(str: string) {
    return str.replace(/\w\S*/g, function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }

  fixName(name: string) {
    return this.toTitleCase(name.replaceAll("_", " ")) || undefined;
  }

  getValue(value: string, unit: string) {
    if (unit === "GENDER") {
      if (value === "1") {
        return "Male";
      } else {
        return "Female";
      }
    }
    return `${value} ${this.toTitleCase(unit.replaceAll("_", " "))}`;
  }

  render() {
    return (
      <GroupRow>
        <Column>
          {this.log?.map((items, index) => (
            <Row key={index}>
              {items?.map((item: any, index: number) => (
                <Column width="50%" key={index}>
                  <SimpleField
                    label={this.fixName(item.measurementType)}
                    value={this.getValue(item.value, item.unit)}
                  />
                </Column>
              ))}
            </Row>
          ))}
        </Column>
      </GroupRow>
    );
  }
}

export default BodyGramDetail;
